import { IModalProps } from 'redux/app/app.types';
import { RootState } from 'redux/store';

export const roleListSelector = (state: RootState) => state.app.roles;

export const modalSelector = (state: RootState): IModalProps => state.app.modal;
// @ts-ignore
export const modalDataSelector = <T>(state: RootState): T => state.app.modal.modalData;
